export interface ServiceNode {
  id: string;
  label: string;
  seq?: number;
  children?: ServiceNode[];
}

export const servicesTree: ServiceNode[] = [
  {
    id: "automation",
    seq: 1,
    label: "Automate Business",
    children: [
      {
        id: "emailAutomation",
        label: "Email Automation",
        children: [
          {
            id: "emailCampaigns",
            label: "Campaigns",
            children: [
              { id: "createCampaign", label: "Create Campaign" },
              { id: "campaignReports", label: "Reports" },
            ],
          },
          {
            id: "emailTemplates",
            label: "Templates",
            children: [
              { id: "createTemplate", label: "Create Template" },
              { id: "templateLibrary", label: "Template Library" },
            ],
          },
        ],
      },
      {
        id: "whatsappAutomation",
        label: "WhatsApp Automation",
        children: [
          {
            id: "broadcast",
            label: "Broadcast",
            children: [
              { id: "createBroadcast", label: "New Broadcast" },
              { id: "broadcastLogs", label: "Logs" },
            ],
          },
          {
            id: "autoReply",
            label: "Auto Reply",
            children: [
              { id: "createAutoReply", label: "Create Rule" },
              { id: "replyAnalytics", label: "Analytics" },
            ],
          },
        ],
      },
      {
        id: "leadAutomation",
        label: "Lead Automation",
        children: [
          {
            id: "leadCapture",
            label: "Lead Capture",
            children: [
              { id: "forms", label: "Forms" },
              { id: "Leadintegrations", label: "Lead Integrations" },
            ],
          },
          {
            id: "followUps",
            label: "Follow Ups",
            children: [
              { id: "sequence", label: "Sequence Builder" },
              { id: "reminders", label: "Reminders" },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "mobileApps",
    seq: 3,

    label: "Mobile Apps",
    children: [
      { id: "allApps", label: "All Apps" },
      { id: "appAnalytics", label: "App Analytics" },
    ],
  },
  {
    id: "social",
    seq: 2,

    label: "Social Media Growth",
    children: [
      {
        id: "youtube",
        label: "YouTube",
        children: [
          {
            id: "videoOptimization",
            label: "Video Optimization",
            children: [
              { id: "tagExtractor", label: "Tag Extractor" },
              { id: "seoSuggestions", label: "SEO Suggestions" },
            ],
          },
          {
            id: "analytics",
            label: "Analytics",
            children: [
              { id: "views", label: "Views & Watch Time" },
              { id: "engagement", label: "Engagement Insights" },
            ],
          },
        ],
      },
      {
        id: "instagramGrowth",
        label: "Instagram",
        children: [
          {
            id: "contentPlanning",
            label: "Content Planning",
            children: [
              { id: "calendar", label: "Content Calendar" },
              { id: "hashtagResearch", label: "Hashtag Research" },
            ],
          },
        ],
      },
    ],
  },

  {
    id: "website",
    seq: 4,

    label: "Website Development",
    children: [
      { id: "allWebsites", label: "All Websites" },
      {
        id: "pages",
        label: "Pages",
        children: [
          { id: "createPage", label: "Create Page" },
          { id: "editPage", label: "Edit Page" },
        ],
      },
      {
        id: "seo",
        label: "SEO Settings",
        children: [
          { id: "metaTags", label: "Meta Tags" },
          { id: "sitemap", label: "Sitemap" },
        ],
      },
    ],
  },

  {
    id: "tools",
    seq: 5,

    label: "Tools & Utilities",
    children: [
      {
        id: "emailTools",
        label: "Email",
        children: [
          { id: "emailValidator", label: "Email Validator" },
          { id: "bulkEmailValidator", label: "Bulk Email Validator" },
        ],
      },
      {
        id: "smsTools",
        label: "SMS",
        children: [{ id: "smsSender", label: "Send SMS" }],
      },
    ],
  },

  /* ✅ NEW TOP-LEVEL INTEGRATIONS SECTION */

  {
    id: "integrations",
    seq: 6,

    label: "Integrations",
    children: [
      { id: "facebook", label: "Facebook" },
      { id: "instagramConnect", label: "Instagram" },
      { id: "youtubeConnect", label: "YouTube" },
      { id: "whatsappConnect", label: "WhatsApp Business" },
      { id: "googleBusiness", label: "Google Business Profile" },
    ],
  },
];
